import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RtbAuthService } from './rtb-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private readonly rtbAuthService: RtbAuthService) { }

  private async canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    const isLoggedIn = await this.rtbAuthService.isLoggedIn();
    if (!isLoggedIn) {
      this.rtbAuthService.login();
    }
    return isLoggedIn;
  }

  public canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(next, state);
  }
}
